
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class TableChips extends Vue {
    @Prop(Array) readonly items!: string[];
    @Prop({ default: 3, type: Number }) limit: number = 3;

    expand(): void {
      this.limit = this.items.length;
    }

    collapse(): void {
      this.limit = 3;
    }
  }
